import update from 'immutability-helper';
import mintModule from '@tunein/mint';
import createMappedReducer from 'src/common/reducers/utils/createMappedReducer';
import {
  MINT_INIT,
  DISPLAY_SLOT_LOADED,
  SEND_LOTAME_INTERESTS,
} from '../actions/mint';
import {
  CLOSE_DOWNLOAD_APP_DIALOG,
  CLOSE_NOW_PLAYING_DIALOG,
  OPEN_DOWNLOAD_APP_DIALOG,
  OPEN_NOW_PLAYING_DIALOG,
} from '../actions/dialog';

const initialState = {
  isInitialized: false,
  deregisterDisplayAds: false,
  previousScreen: '',
  loadedDisplaySlotId: '',
  lotameInterests: [],
};

export const mint = createMappedReducer(initialState, {
  // mint actions
  [MINT_INIT](state) {
    return {
      ...state,
      isInitialized: true,
    };
  },
  [DISPLAY_SLOT_LOADED](state, action) {
    return update(state, {
      loadedDisplaySlotId: { $set: action.elementId },
    });
  },

  // other actions
  [OPEN_NOW_PLAYING_DIALOG](state) {
    const previousScreen = mintModule.getState('currentScreen');
    mintModule.updateState('currentScreen', 'nowPlaying');
    return {
      ...state,
      deregisterDisplayAds: true,
      previousScreen,
    };
  },
  [CLOSE_NOW_PLAYING_DIALOG](state) {
    mintModule.updateState('currentScreen', state.previousScreen);
    return {
      ...state,
      deregisterDisplayAds: false,
      previousScreen: '',
    };
  },
  [OPEN_DOWNLOAD_APP_DIALOG](state) {
    return {
      ...state,
      deregisterDisplayAds: true,
    };
  },
  [CLOSE_DOWNLOAD_APP_DIALOG](state) {
    return {
      ...state,
      deregisterDisplayAds: false,
    };
  },
  [SEND_LOTAME_INTERESTS](state, { interests }) {
    return { ...state, lotameInterests: interests };
  },
});
